const domainTag = 'frontend_portal_';

const portalBooleanFlagNames = [
  'menuV3_enableQa',
  'marketplaceIntegration_DeliverooV2',
  'menuV3_externalIdInvalidator',
  'menuV3_pricebandBulkActions',
  'menuV3_enableImageDisplaySize',
] as const;

type PortalBooleanFlagName = (typeof portalBooleanFlagNames)[number];

export type PortalBooleanFlagKey = `${typeof domainTag}${PortalBooleanFlagName}`;

type PortalBooleanFlagKeysShape = {
  readonly [Name in PortalBooleanFlagName]: `${typeof domainTag}${Name}`;
};

export const PortalBooleanFlagKeys = Object.fromEntries(
  portalBooleanFlagNames.map((name) => [name, `${domainTag}${name}`])
) as PortalBooleanFlagKeysShape;
